import React from 'react';
import PropTypes from 'prop-types';

import './ZRCalloutInfoTooltip.less';

/**
 * WARNING
 *
 * This component relies on JQuery and zrCallout being on the page.
 *
 * If the tooltip doesn't render, make sure these imports exist on the page:
 *   link_css_file('/css/plugins/zrCallout.less');
 *   link_js_file('/js/vendor/popper.js/1.15.0/popper.js');
 *   link_js_file('/js/plugins/jquery.zrCallout.js');
 *   link_js_file('/js/common/zrCallout.bind.js');
 *
 * https://frontend.zr.org/fedocs/examples#jquery-plugins-callout
 */

const ZRCalloutInfoTooltip = ({ title }) => (
  <button
    type="button"
    className="zr_callout_tooltip"
    data-callout="tooltip"
    aria-label="information tooltip"
    title={title}
  />
);

ZRCalloutInfoTooltip.propTypes = {
  title: PropTypes.string.isRequired,
};

export default ZRCalloutInfoTooltip;
